
<div class="row">
  <div class="col">
    <app-observations-list [showWarningMessage]="showWarningMessage" [showAddButton]="true"
                           [observations]="observations" [addButtonText]="addButtonText"
                           [tableTitle]="'Operative Observations'" [companyId]="companyId" [showCaption]="true"
                           (createObservationClicked)="createObservation($event)"
                           [allowedOperations]="allowedOperations"
                           (editObservationClicked)="editObservation($event)"></app-observations-list>
  </div>
</div>
